import { lazy } from "react";

export const LazyPromotionsHub = lazy(() =>
  import(
    /* webpackChunkName: "promotions-hub-2022" */ "./LandingPage/PromotionsHub"
  ).then((m) => ({ default: m.PromotionsHub }))
);

export const LazyMyMarketList = lazy(() =>
  import(
    /* webpackChunkName: "my-market-list-2022" */ "./MarketList/MyMarketList"
  ).then((m) => ({ default: m.MyMarketList }))
);
